import React from "react";

import Layout from "../../components/layout";
import SEO from "../../components/SEO";
import { HarmindraInternationalProductCatalogueProjectSection } from "../../containers/projects";

const HarmindraInternationalProductCatalogue = () => {
  return (
    <Layout>
      <SEO
        title="Harmindra International - Projects"
        description="Product catalogue website establishing online identity for an Indian manufacturing firm | Manufacturing | Year: 2021 | TypeScript, Gatsby, Material UI, Contentful CMS"
      />
      <HarmindraInternationalProductCatalogueProjectSection />
    </Layout>
  );
};

export default HarmindraInternationalProductCatalogue;
